/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import TableComponent from "../../components/TableComponent";
import AddCategory from "../../Modals/addCategory";
import IosSwitchMain from "../../components/iosSwitchMain";
import { GridColDef } from "@mui/x-data-grid";

const CategoryList = ({ activeTab }: { activeTab: number }) => {
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => setOpen(false);

  // Default rows
  const defaultRows = [
    { id: 1, name: "Dining", date: "12-04-2025" },
    { id: 2, name: "Events", date: "12-04-2025" },
    { id: 3, name: "Dining", date: "12-04-2025" },
    { id: 4, name: "Events", date: "12-04-2025" },
  ];

  // For Internal Process tab: overwrite names with internal statuses
  const internalStatuses = ["In Progress", "Pending Venue", "Pending Member"];
  const rows =
    activeTab === 1
      ? defaultRows.map((row, index) => ({
          ...row,
          name: internalStatuses[index % internalStatuses.length],
        }))
      : defaultRows;

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 50,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 150,
      field: "image",
      headerName: "Image",
      editable: false,
      sortable: false,
      renderCell: () => (
        <div className="user_block click_action">
          <figure>
            <img
              src="/static/images/user_placeholder.png"
              alt="Category"
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </figure>
        </div>
      ),
    },
    {
      flex: 2,
      minWidth: 150,
      field: "name",
      headerName: "Category Name",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 100,
      field: "show",
      headerName: "Show",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => <IosSwitchMain />,
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => (
        <div className="table_actions v2">
          <Box>
            <IconButton onClick={() => setOpen(true)}>
              <img src="/static/images/edit_icon.svg" alt="Edit" />
            </IconButton>
          </Box>
          <Box>
            <IconButton>
              <img src="/static/images/trash2_icon.svg" alt="Delete" />
            </IconButton>
          </Box>
        </div>
      ),
    },
    {
      minWidth: 150,
      field: "drag",
      headerName: "Drag & Drop",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: () => (
        <div className="table_actions v2">
          <Box>
            <IconButton className="drag_btn">
              <MenuIcon />
            </IconButton>
          </Box>
        </div>
      ),
    },
  ];

  // Hide columns conditionally for Internal Process tab
  const filteredColumns = columns.filter((col) => {
    if (activeTab === 1) {
      // Hide "image", "date", and "drag"
      return col.field !== "image" && col.field !== "date" && col.field !== "drag";
    }
    return true;
  });

  return (
    <>
      <div className="sorting_table">
        <TableComponent columns={filteredColumns} rows={rows} />
      </div>

      <AddCategory open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default CategoryList;
